(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["popup-sign-up"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const TAG = 'xo-popup-signup-reopen';
    if (customElements.get(TAG)) return;

    const FREQUENCY_SECONDS = {
      once: Infinity,
      every_hour: 3600,
      every_12_hour: 43200,
      every_12_hours: 43200,
      every_day: 86400,
      every_3_day: 259200,
      every_week: 604800,
      every_2_weeks: 1209600,
      no_limit: 0
    };
    const POPUP_STORAGE_KEY = 'xo-popup-sign-up';

    /**
     * @returns {Storage | { getItem: Function, setItem: Function } | null}
     */
    function getPopupStorage() {
      const storage = window.XotinyUtils && window.XotinyUtils.storage;
      if (storage && typeof storage.getItem === 'function') return storage;
      try {
        return window.localStorage;
      } catch (error) {
        return null;
      }
    }

    /**
     * @returns {Storage | null}
     */
    function getSessionStorage() {
      try {
        return window.sessionStorage;
      } catch (error) {
        return null;
      }
    }

    /**
     * @param {string | null} frequency
     * @returns {boolean}
     */
    function shouldAutoOpenPopup(frequency) {
      const limit = FREQUENCY_SECONDS[frequency || 'once'];
      const stored = getPopupStorage()?.getItem(POPUP_STORAGE_KEY);
      const now = Math.floor(Date.now() / 1000);
      if (limit === 0 || !stored) return true;
      return now - parseInt(stored, 10) >= limit;
    }

    class XoPopupSignupReopen extends HTMLElement {
      /** @type {MutationObserver | null} */
      #observer = null;
      /** @type {HTMLElement | null} */
      #modal = null;
      /** @type {HTMLElement | null} */
      #popup = null;
      /** @type {HTMLButtonElement | null} */
      #trigger = null;
      /** @type {HTMLButtonElement | null} */
      #dismiss = null;
      /** @type {HTMLFormElement | null} */
      #form = null;
      #dismissed = false;
      #subscribed = false;

      connectedCallback() {
        this.#popup = this.closest('xo-popup-sign-up');
        this.#modal = this.#popup ? this.#popup.querySelector('xo-modal') : null;
        this.#trigger = this.querySelector('.xo-popup-signup__reopen-trigger');
        this.#dismiss = this.querySelector('.xo-popup-signup__reopen-dismiss');
        this.#form = this.dataset.formId ? document.getElementById(this.dataset.formId) : null;

        this.#form?.addEventListener('submit', this.#handleFormSubmit);
        this.#resolveSubscription();

        const session = getSessionStorage();
        const dismissKey = this.dataset.dismissKey;
        this.#dismissed = Boolean(dismissKey && session && session.getItem(dismissKey));

        if (this.#dismissed || this.#subscribed || !this.#popup || !this.#modal) {
          this.#hide(true);
          return;
        }

        this.#trigger?.addEventListener('click', this.#handleReopen);
        this.#dismiss?.addEventListener('click', this.#handleDismiss);

        this.#observer = new MutationObserver(this.#handleModalMutation);
        this.#observer.observe(this.#modal, { attributes: true, attributeFilter: ['xo-active'] });

        this.#syncVisibility(true);
        if (document.readyState !== 'complete') {
          window.addEventListener('load', this.#handleWindowLoad, { once: true });
        }
      }

      disconnectedCallback() {
        this.#trigger?.removeEventListener('click', this.#handleReopen);
        this.#dismiss?.removeEventListener('click', this.#handleDismiss);
        this.#form?.removeEventListener('submit', this.#handleFormSubmit);
        window.removeEventListener('load', this.#handleWindowLoad);
        this.#observer?.disconnect();
        this.#observer = null;
      }

      /**
       * Flags that this popup's form is the one being submitted, so the reload
       * that follows can tell it apart from any other customer form on the page.
       */
      #handleFormSubmit = () => {
        const session = getSessionStorage();
        const pendingKey = this.#pendingKey();
        if (session && pendingKey) session.setItem(pendingKey, '1');
      };

      /**
       * Marks the session as subscribed when the reload comes from this form
       * being posted successfully.
       */
      #resolveSubscription() {
        const session = getSessionStorage();
        const subscribedKey = this.dataset.subscribedKey;
        const pendingKey = this.#pendingKey();
        if (!session || !subscribedKey) return;

        const wasPending = Boolean(pendingKey && session.getItem(pendingKey));
        if (pendingKey) session.removeItem(pendingKey);

        if (this.dataset.formPosted === 'true' && wasPending) {
          session.setItem(subscribedKey, String(Math.floor(Date.now() / 1000)));
        }

        this.#subscribed = Boolean(session.getItem(subscribedKey));
      }

      /**
       * @returns {string} Session key used to track a submit awaiting its reload.
       */
      #pendingKey() {
        const subscribedKey = this.dataset.subscribedKey;
        return subscribedKey ? `${subscribedKey}-pending` : '';
      }

      #handleReopen = () => {
        const modalName = this.dataset.modalName;
        if (!modalName || !window.xoModal) return;
        window.xoModal.open(modalName);
      };

      #handleDismiss = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.#dismissed = true;
        const session = getSessionStorage();
        const dismissKey = this.dataset.dismissKey;
        if (session && dismissKey) session.setItem(dismissKey, String(Math.floor(Date.now() / 1000)));
        this.#hide(true);
      };

      #handleModalMutation = () => {
        this.#syncVisibility(false);
      };

      #handleWindowLoad = () => {
        this.#syncVisibility(true);
      };

      /**
       * @param {boolean} isInitial
       */
      #syncVisibility(isInitial) {
        if (this.#dismissed || this.#subscribed) {
          this.#hide(true);
          return;
        }

        const isOpen = this.#modal?.hasAttribute('xo-active');
        if (isOpen) {
          this.#hide(true);
          this.#setExpanded(true);
          return;
        }

        this.#setExpanded(false);

        const frequency = this.#popup?.getAttribute('xo-frequency');
        const alreadyShown = Boolean(getPopupStorage()?.getItem(POPUP_STORAGE_KEY));

        if (isInitial && (!alreadyShown || shouldAutoOpenPopup(frequency))) {
          this.#hide(true);
          return;
        }

        this.#show();
      }

      #show() {
        if (this.#dismissed || this.#subscribed) return;
        this.hidden = false;
        this.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => {
          this.classList.add('is-visible');
        });
      }

      /**
       * @param {boolean} immediate
       */
      #hide(immediate) {
        this.classList.remove('is-visible');
        this.setAttribute('aria-hidden', 'true');
        if (immediate) {
          this.hidden = true;
          return;
        }
        window.setTimeout(() => {
          if (!this.classList.contains('is-visible')) this.hidden = true;
        }, 300);
      }

      /**
       * @param {boolean} expanded
       */
      #setExpanded(expanded) {
        this.#trigger?.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    }

    customElements.define(TAG, XoPopupSignupReopen);
  })();

  } catch(e) { console.error(e); }
})();
})();
